import { render, staticRenderFns } from "./FieldsDropdownCities.vue?vue&type=template&id=0a5d6c54&"
import script from "./FieldsDropdownCities.vue?vue&type=script&lang=js&"
export * from "./FieldsDropdownCities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports